(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8747],{

/***/ 1752:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(2156)


/***/ }),

/***/ 7348:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5444);
/* harmony import */ var _constants_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7579);
/* harmony import */ var react_zendesk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7245);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);




var colors = _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors */ .r.colors;
var StyledLiveChatTextLink = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "LiveChatTextLink__StyledLiveChatTextLink",
  componentId: "sc-83vx6z-0"
})(["color:", ";text-decoration:underline;cursor:pointer;"], colors.blue[500]);

var LiveChatTextLink = function LiveChatTextLink() {
  var handleChat = function handleChat() {
    (0,react_zendesk__WEBPACK_IMPORTED_MODULE_1__/* .ZendeskAPI */ .Q9)('webWidget', 'show');
    (0,react_zendesk__WEBPACK_IMPORTED_MODULE_1__/* .ZendeskAPI */ .Q9)('webWidget', 'open');
    (0,react_zendesk__WEBPACK_IMPORTED_MODULE_1__/* .ZendeskAPI */ .Q9)('webWidget:on', 'close', function () {
      (0,react_zendesk__WEBPACK_IMPORTED_MODULE_1__/* .ZendeskAPI */ .Q9)('webWidget', 'hide');
    });
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(StyledLiveChatTextLink, {
    onClick: handleChat,
    children: "LIVE CHAT"
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (LiveChatTextLink);

/***/ }),

/***/ 5820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5444);
/* harmony import */ var _constants_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7579);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);




var colors = _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors */ .r.colors,
    devices = _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.devices */ .r.devices,
    fontSizes = _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontSizes */ .r.fontSizes,
    spaces = _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.spaces */ .r.spaces;
var StyledBannerContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "AboutBannerSection__StyledBannerContainer",
  componentId: "sc-13zc8xh-0"
})(["display:flex;justify-content:space-between;flex-direction:column;position:relative;align-items:center;max-width:", "px;padding-top:", "px;padding-bottom:", "px;@media ", "{padding-left:", "px;padding-right:", "px;padding-top:", "px;padding-bottom:", "px;}"], spaces.large24X * 10 + 80, spaces.large12X - 2, spaces.large24X, devices.tablet, spaces.regular, spaces.regular, spaces.regular, spaces.regular);
var StyledBannerImageContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "AboutBannerSection__StyledBannerImageContainer",
  componentId: "sc-13zc8xh-1"
})(["", " img{max-width:100%;max-height:100%;}"], function (_ref) {
  var width = _ref.width;
  return width && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(["width:", "px;"], width);
});
var StyledBannerContentContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "AboutBannerSection__StyledBannerContentContainer",
  componentId: "sc-13zc8xh-2"
})(["display:flex;flex-direction:column;justify-content:center;@media ", "{padding-right:0;width:100%;}"], devices.tablet);
var StyledBannerHeaderSection = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "AboutBannerSection__StyledBannerHeaderSection",
  componentId: "sc-13zc8xh-3"
})(["margin-bottom:", "px;font-family:'Aeonik';font-style:normal;font-size:", "px;font-weight:500;color:", ";text-align:center;@media ", "{font-size:", "px;margin-bottom:", "px;}"], spaces.large2X - 2, fontSizes.large11X, colors.gray[800], devices.tablet, fontSizes.large2X, spaces.large);
var StyledBannerSubHeaderSection = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "AboutBannerSection__StyledBannerSubHeaderSection",
  componentId: "sc-13zc8xh-4"
})(["margin-bottom:", "px;font-family:'Aeonik';font-style:normal;font-size:", "px;font-weight:400;color:", ";text-align:center;@media ", "{font-size:", "px;margin-bottom:", "px;}"], spaces.large9X, fontSizes.large, colors.gray[700], devices.tablet, fontSizes.regular, spaces.large3X);

var AboutBannerSection = function AboutBannerSection(_ref2) {
  var imgSrc = _ref2.imgSrc,
      header = _ref2.header,
      subHeader = _ref2.subHeader;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledBannerContainer, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledBannerContentContainer, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledBannerHeaderSection, {
        children: header
      }), subHeader && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledBannerSubHeaderSection, {
        children: subHeader
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledBannerImageContainer, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("picture", {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("source", {
          srcSet: imgSrc,
          type: "image/png"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
          src: imgSrc,
          alt: "Banner image"
        })]
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (AboutBannerSection);

/***/ }),

/***/ 2410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_innova_labs_developers_trademark_trademark_frontend_v2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var _builds_innova_labs_developers_trademark_trademark_frontend_v2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4730);
/* harmony import */ var _constants_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7579);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5444);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5893);


var _excluded = ["moreSpace", "imgTopDesktopPosition"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_builds_innova_labs_developers_trademark_trademark_frontend_v2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var colors = _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors */ .r.colors,
    devices = _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.devices */ .r.devices,
    fontSizes = _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.fontSizes */ .r.fontSizes,
    spaces = _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.spaces */ .r.spaces;
var StyledBottomBannerContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "BottomBannerSection__StyledBottomBannerContainer",
  componentId: "sc-rgywhc-0"
})(["position:relative;display:flex;flex-direction:column;align-items:center;width:100%;margin-bottom:", "px;margin-top:", "px;@media ", "{margin-bottom:", "px;margin-top:", "px;}"], spaces.large24X, spaces.large24X, devices.tablet, spaces.large9X, spaces.large9X);
var StyledDisclaimer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "BottomBannerSection__StyledDisclaimer",
  componentId: "sc-rgywhc-1"
})(["max-width:", "px;width:100%;text-align:center;margin-top:", "px;font-family:'Aeonik';font-style:normal;font-weight:400;font-size:", "px;line-height:150%;color:", ";@media ", "{padding-left:", "px;padding-right:", "px;}"], spaces.large24X * 10 + 80, spaces.regular, fontSizes.regular, colors.gray[500], devices.tablet, spaces.regular, spaces.regular); // eslint-disable-next-line prettier/prettier, react/display-name

var StyledBottomBannerSection = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)( /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function (_ref, ref) {
  var moreSpace = _ref.moreSpace,
      imgTopDesktopPosition = _ref.imgTopDesktopPosition,
      props = (0,_builds_innova_labs_developers_trademark_trademark_frontend_v2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", _objectSpread({
    ref: ref
  }, props));
})).withConfig({
  displayName: "BottomBannerSection__StyledBottomBannerSection",
  componentId: "sc-rgywhc-2"
})(["display:flex;justify-content:space-between;background:", ";border-radius:40px;max-width:", "px;width:100%;padding-left:", "px;padding-right:", "px;padding-top:", "px;padding-bottom:", "px;.header{font-family:'Aeonik';font-style:normal;font-weight:500;font-size:", "px;line-height:130%;color:", ";flex:none;order:0;align-self:stretch;flex-grow:0;margin-bottom:", "px;margin-right:", "px;}.footer{font-family:'Aeonik';font-style:normal;font-weight:400;font-size:", "px;line-height:150%;color:", ";display:flex;flex-direction:row;justify-content:space-between;align-items:center;}.column1{padding-right:", "px;}.column2{margin-top:", ";margin-bottom:-60px;margin-right:-55px;}@media ", "{margin-left:0;margin-right:0;border-radius:0px;box-shadow:0px 30px 80px rgba(0,0,0,0.05);padding-left:", "px;padding-right:", "px;padding-top:", "px;padding-bottom:", "px;align-items:center;.header{font-size:", "px;line-height:150%;margin-bottom:", "px;margin-right:", "px;}.footer{font-size:", "px;line-height:24px;flex-direction:column;align-items:flex-start;gap:10px;}.column2{margin:0;img{height:120px;}}}"], colors.blue[600], spaces.large24X * 10 + 80, spaces.large14X, spaces.large14X, spaces.large9X, spaces.large9X, fontSizes.large11X, colors.white, function (_ref2) {
  var moreSpace = _ref2.moreSpace;
  return moreSpace ? spaces.large4X : spaces.medium;
}, spaces.large14X, fontSizes.large, colors.blue[100], spaces.regular, function (_ref3) {
  var imgTopDesktopPosition = _ref3.imgTopDesktopPosition;
  return imgTopDesktopPosition || 0;
}, devices.tablet, spaces.regular, spaces.regular, spaces.large, spaces.large, fontSizes.large, function (_ref4) {
  var moreSpace = _ref4.moreSpace;
  return moreSpace ? spaces.regular : spaces.smallX;
}, spaces.smallX, fontSizes.regular);

var BottomBannerSection = function BottomBannerSection(_ref5) {
  var header = _ref5.header,
      footer = _ref5.footer,
      imgSrc = _ref5.imgSrc,
      imgTopDesktopPosition = _ref5.imgTopDesktopPosition,
      moreSpace = _ref5.moreSpace,
      disclaimer = _ref5.disclaimer;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(StyledBottomBannerContainer, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(StyledBottomBannerSection, {
      imgTopDesktopPosition: imgTopDesktopPosition,
      moreSpace: moreSpace,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
        className: "column1",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
          className: "header",
          children: header
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
          className: "footer",
          children: footer
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        className: "column2",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("picture", {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("source", {
            srcSet: imgSrc,
            type: "image/png"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("img", {
            src: imgSrc,
            alt: "Banner image"
          })]
        })
      })]
    }), disclaimer && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledDisclaimer, {
      children: "All information submitted to Trademark Genius shall be regarded as strictly confidential. Trademark Genius will not reveal any intellectual property information to any organization other than as necessary for submission to the USPTO."
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (BottomBannerSection);

/***/ }),

/***/ 1450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _constants_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7579);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5444);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);





var colors = _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors */ .r.colors,
    devices = _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.devices */ .r.devices,
    fontSizes = _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontSizes */ .r.fontSizes,
    spaces = _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.spaces */ .r.spaces;
var StyledWhyTrademarkSection = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "WhySection__StyledWhyTrademarkSection",
  componentId: "sc-1671cdm-0"
})(["max-width:", "px;display:flex;flex-direction:column;margin-bottom:", "px;.headerSection{margin-left:", "px;margin-right:", "px;font-family:'Aeonik';font-style:normal;font-weight:500;font-size:", "px;line-height:130%;text-align:center;color:", ";flex:none;order:0;align-self:stretch;flex-grow:0;}@media ", "{padding-left:", "px;padding-right:", "px;}@media ", "{margin-top:", "px;margin-bottom:", "px;margin-left:0px;margin-right:0px;display:flex;flex-direction:column;justify-content:center;align-items:center;gap:0px;flex:none;order:1;flex-grow:0;.headerSection{font-size:", "px;line-height:150%;}}"], spaces.large24X * 10 + 80, function (_ref) {
  var isMarginBottom = _ref.isMarginBottom;
  return isMarginBottom ? spaces.large24X : 0;
}, spaces.regular, spaces.regular, fontSizes.large11X, colors.gray[800], devices.laptopM, spaces.large2X, spaces.large2X, devices.tablet, spaces.large9X, spaces.large9X, fontSizes.large2X);
var StyledWhyTrademarkContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "WhySection__StyledWhyTrademarkContainer",
  componentId: "sc-1671cdm-1"
})(["display:flex;gap:", "px;margin-top:", "px;", " @media ", "{gap:0px;flex-direction:column;margin-top:", "px;", "}"], spaces.large2X - 2, spaces.large2X, function (_ref2) {
  var reverse = _ref2.reverse;
  return reverse && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(["flex-direction:row-reverse;"]);
}, devices.tablet, spaces.smallX, function (_ref3) {
  var reverse = _ref3.reverse;
  return reverse && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(["flex-direction:column-reverse;"]);
});
var StyledWhyLeft = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "WhySection__StyledWhyLeft",
  componentId: "sc-1671cdm-2"
})(["flex-grow:1;flex-direction:column;width:50%;text-align:right;display:flex;align-items:flex-end;justify-content:end;img{max-width:100%;max-height:100%;width:570px;}.imageHeader{text-align:left;font-family:'Aeonik';font-style:normal;font-weight:500;font-size:36px;line-height:150%;color:#344054;max-width:570px;margin-bottom:37px;}@media ", "{display:none;", "}"], devices.tablet, function (_ref4) {
  var isLeftMobileView = _ref4.isLeftMobileView;
  return isLeftMobileView && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(["padding-left:16px;padding-right:16px;display:block;width:100%;.imageHeader{font-size:20px;text-align:center;margin-bottom:24px;}"]);
});
var StyledWhyRight = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "WhySection__StyledWhyRight",
  componentId: "sc-1671cdm-3"
})(["flex-grow:1;width:50%;display:flex;flex-direction:column;align-items:flex-start;", " ", " @media ", "{border-radius:0px;padding:0;width:100%;", "}"], function (_ref5) {
  var isFullRight = _ref5.isFullRight;
  return isFullRight && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(["padding:", "px;gap:", "px;background-color:", ";box-shadow:0px 10px 80px rgba(0,0,0,0.05);border-radius:50px;"], spaces.large4X, spaces.large4X, colors.white);
}, function (_ref6) {
  var reverse = _ref6.reverse;
  return reverse && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(["justify-content:center;"]);
}, devices.tablet, function (_ref7) {
  var isFullRight = _ref7.isFullRight;
  return isFullRight && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(["gap:", "px;background-color:rgba(0,0,0,0.02);"], spaces.large2X);
});

var WhySection = function WhySection(_ref8) {
  var title = _ref8.title,
      imageTitle = _ref8.imageTitle,
      leftImage = _ref8.leftImage,
      rightPart = _ref8.rightPart,
      isFullRight = _ref8.isFullRight,
      isMarginBottom = _ref8.isMarginBottom,
      reverse = _ref8.reverse,
      isLeftMobileView = _ref8.isLeftMobileView;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(StyledWhyTrademarkSection, {
    isMarginBottom: isMarginBottom,
    children: [title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: "headerSection",
      children: title
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(StyledWhyTrademarkContainer, {
      reverse: reverse,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(StyledWhyLeft, {
        isLeftMobileView: isLeftMobileView,
        children: [imageTitle && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
          className: "imageHeader",
          children: imageTitle
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("picture", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("img", {
            src: leftImage,
            alt: ""
          })
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(StyledWhyRight, {
        isFullRight: isFullRight,
        reverse: reverse,
        children: rightPart
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (WhySection);

/***/ }),

/***/ 573:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Guarantee; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(5444);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(1752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(7333);
// EXTERNAL MODULE: ./_config/index.js
var _config = __webpack_require__(8002);
// EXTERNAL MODULE: ./_constants/icons.js
var icons = __webpack_require__(934);
// EXTERNAL MODULE: ./_constants/theme.js
var theme = __webpack_require__(7579);
// EXTERNAL MODULE: ./_constants/routes.js
var routes = __webpack_require__(672);
// EXTERNAL MODULE: ./_components/composed/sections/AboutBannerSection/index.jsx
var AboutBannerSection = __webpack_require__(5820);
// EXTERNAL MODULE: ./_components/composed/sections/BottomBannerSection/index.jsx
var BottomBannerSection = __webpack_require__(2410);
// EXTERNAL MODULE: ./_components/composed/sections/WhySection/index.jsx
var WhySection = __webpack_require__(1450);
// EXTERNAL MODULE: ./_components/atomic/Button/index.jsx
var Button = __webpack_require__(8509);
// EXTERNAL MODULE: ./_components/atomic/Icon/index.jsx + 49 modules
var Icon = __webpack_require__(6668);
// EXTERNAL MODULE: ./_components/atomic/LiveChatTextLink/index.jsx
var LiveChatTextLink = __webpack_require__(7348);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./_components/composed/pages/GuaranteePage/index.jsx


var _excluded = ["size", "rotate", "top", "bottom", "left", "right"],
    _excluded2 = ["top", "bottom", "left", "right"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



















var colors = theme/* theme.colors */.r.colors,
    devices = theme/* theme.devices */.r.devices,
    fontSizes = theme/* theme.fontSizes */.r.fontSizes,
    spaces = theme/* theme.spaces */.r.spaces;

var _getConfig = config_default()(),
    publicRuntimeConfig = _getConfig.publicRuntimeConfig;

var StyledGuaranteePage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "GuaranteePage__StyledGuaranteePage",
  componentId: "sc-q81gne-0"
})(["position:relative;display:flex;flex-direction:column;align-items:center;.ourProcessingText{margin-bottom:", "px;p{font-family:'Aeonik';font-style:normal;font-weight:400;font-size:", "px;line-height:150%;color:", ";}}@media ", "{display:block;margin-top:", "px;.ourProcessingText p{font-size:", "px;padding-left:", "px;padding-right:", "px;}}"], spaces.large3X, fontSizes.large, colors.gray[700], devices.tablet, spaces.regular, fontSizes.regular, spaces.regular, spaces.regular); // eslint-disable-next-line prettier/prettier, react/display-name

var StyledCircle = (0,styled_components_browser_esm/* default */.ZP)( /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var size = _ref.size,
      rotate = _ref.rotate,
      top = _ref.top,
      bottom = _ref.bottom,
      left = _ref.left,
      right = _ref.right,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", _objectSpread({
    ref: ref
  }, props));
})).withConfig({
  displayName: "GuaranteePage__StyledCircle",
  componentId: "sc-q81gne-1"
})(["position:absolute;background:", ";border-radius:50%;opacity:0.1;z-index:-1;", " ", " ", " ", " ", " ", " @media ", "{display:none;}"], "linear-gradient(180deg, ".concat(theme/* theme.colors.blue.500 */.r.colors.blue[500], " 0%, rgba(46, 144, 250, 0) 100%)"), function (_ref2) {
  var top = _ref2.top;
  return typeof top !== 'undefined' && (0,styled_components_browser_esm/* css */.iv)(["top:", ";"], typeof top === 'string' ? top : "".concat(top, "px"));
}, function (_ref3) {
  var bottom = _ref3.bottom;
  return typeof bottom !== 'undefined' && (0,styled_components_browser_esm/* css */.iv)(["bottom:", ";"], typeof bottom === 'string' ? bottom : "".concat(bottom, "px"));
}, function (_ref4) {
  var left = _ref4.left;
  return typeof left !== 'undefined' && (0,styled_components_browser_esm/* css */.iv)(["left:", ";"], typeof left === 'string' ? left : "".concat(left, "px"));
}, function (_ref5) {
  var right = _ref5.right;
  return typeof right !== 'undefined' && (0,styled_components_browser_esm/* css */.iv)(["right:", ";"], typeof right === 'string' ? right : "".concat(right, "px"));
}, function (_ref6) {
  var rotate = _ref6.rotate;
  return rotate && (0,styled_components_browser_esm/* css */.iv)(["transform:", ";"], "rotate(".concat(rotate, "deg)"));
}, function (_ref7) {
  var size = _ref7.size;
  return size && (0,styled_components_browser_esm/* css */.iv)(["width:", "px;height:", "px;"], size, size);
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.devices.tablet;
}); // eslint-disable-next-line prettier/prettier, react/display-name

var StyledImageContainer = (0,styled_components_browser_esm/* default */.ZP)( /*#__PURE__*/(0,react.forwardRef)(function (_ref9, ref) {
  var top = _ref9.top,
      bottom = _ref9.bottom,
      left = _ref9.left,
      right = _ref9.right,
      props = (0,objectWithoutProperties/* default */.Z)(_ref9, _excluded2);

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", _objectSpread({
    ref: ref
  }, props));
})).withConfig({
  displayName: "GuaranteePage__StyledImageContainer",
  componentId: "sc-q81gne-2"
})(["position:absolute;z-index:-1;", " ", " ", " ", " @media ", "{display:none;}"], function (_ref10) {
  var top = _ref10.top;
  return typeof top !== 'undefined' && (0,styled_components_browser_esm/* css */.iv)(["top:", ";"], typeof top === 'string' ? top : "".concat(top, "px"));
}, function (_ref11) {
  var bottom = _ref11.bottom;
  return typeof bottom !== 'undefined' && (0,styled_components_browser_esm/* css */.iv)(["bottom:", ";"], typeof bottom === 'string' ? bottom : "".concat(bottom, "px"));
}, function (_ref12) {
  var left = _ref12.left;
  return typeof left !== 'undefined' && (0,styled_components_browser_esm/* css */.iv)(["left:", ";"], typeof left === 'string' ? left : "".concat(left, "px"));
}, function (_ref13) {
  var right = _ref13.right;
  return typeof right !== 'undefined' && (0,styled_components_browser_esm/* css */.iv)(["right:", ";"], typeof right === 'string' ? right : "".concat(right, "px"));
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.devices.tablet;
});

var GuaranteePage = function GuaranteePage() {
  var _config$phone;

  var router = (0,next_router.useRouter)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledGuaranteePage, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AboutBannerSection/* default */.Z, {
      header: "Our Guarantee",
      imgSrc: "".concat(_config/* config.basePath */.v.basePath, "/images/guarantee.svg"),
      subHeader: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: "Still have questions? Call"
        }), "\xA0", /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "tel:".concat(_config/* config.phone */.v.phone),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_number_format_es/* PatternFormat */.HH, {
            value: (_config$phone = _config/* config.phone */.v.phone) === null || _config$phone === void 0 ? void 0 : _config$phone.substring(2),
            displayType: "text",
            format: "(###) ###-####"
          })
        }), "\xA0", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: "or"
        }), "\xA0", /*#__PURE__*/(0,jsx_runtime.jsx)(LiveChatTextLink/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          children: [", or send an email to", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "mailto:".concat(_config/* config.email */.v.email),
            children: "support@trademark-genius.com"
          }), ' ', "for real-time support."]
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(WhySection/* default */.Z, {
      isLeftMobileView: true,
      reverse: true,
      leftImage: "".concat(_config/* config.basePath */.v.basePath, "/images/guarantee-why.png"),
      rightPart: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "ourProcessingText",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "The team at Trademark Genius has its customers as its sole focus. We are dedicated to providing top notch service and customer support to our customers. We will use our knowledge, and software, to ensure timely processing of your order, to ensure you the fastest submission to the USPTO."
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
          children: ["However, if you feel we haven\u2019t lived up to our end of the bargain, you may request a refund by e-mail, to", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "mailto:".concat(_config/* config.email */.v.email, "?subject=Mail from Guarantee Trademark Site"),
            children: _config/* config.email */.v.email
          }), ". Please note that USPTO Government filing fees are *non-refundable* under any circumstances once your application has been submitted to the United States Patent and Trademark Office."]
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(BottomBannerSection/* default */.Z, {
      header: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: "Don't wait, Protect Your Brand now"
      }),
      footer: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        suffix: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
          alias: icons/* ICONS_ALIASES.arrowRight */.F.arrowRight,
          color: theme/* theme.colors.blue.500 */.r.colors.blue[500]
        }),
        color: theme/* theme.colors.white */.r.colors.white,
        onClick: function onClick() {
          return router.push(routes/* ROUTES.trademarkRegistration */.Z.trademarkRegistration);
        },
        textColor: theme/* theme.colors.blue.500 */.r.colors.blue[500],
        hoverColor: theme/* theme.colors.white */.r.colors.white,
        hoverTextColor: theme/* theme.colors.blue.500 */.r.colors.blue[500],
        children: "Start Registering Now"
      }),
      imgSrc: "".concat(_config/* config.basePath */.v.basePath, "/images/trademark-registration-bottom.svg"),
      imgTopDesktopPosition: "-130px",
      moreSpace: true,
      disclaimer: true
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledCircle, {
      size: 686,
      rotate: -90,
      left: -63,
      top: -199
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledImageContainer, {
      left: -44,
      top: 285,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("picture", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("source", {
          srcSet: "".concat(publicRuntimeConfig.basePath, "/images/dots.svg"),
          type: "image/svg"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: "".concat(publicRuntimeConfig.basePath, "/images/dots.svg"),
          alt: ""
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledCircle, {
      size: 686,
      rotate: -90,
      left: -232,
      top: 'calc(53% + 30px)'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledImageContainer, {
      left: 65,
      top: 'calc(71% + 60px)',
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("picture", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("source", {
          srcSet: "".concat(publicRuntimeConfig.basePath, "/images/dots.svg"),
          type: "image/svg"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: "".concat(publicRuntimeConfig.basePath, "/images/dots.svg"),
          alt: ""
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledCircle, {
      size: 686,
      rotate: 90,
      right: -199,
      top: 155
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledImageContainer, {
      right: -66,
      top: 78,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("picture", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("source", {
          srcSet: "".concat(publicRuntimeConfig.basePath, "/images/dots.svg"),
          type: "image/svg"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: "".concat(publicRuntimeConfig.basePath, "/images/dots.svg"),
          alt: ""
        })]
      })
    })]
  });
};

/* harmony default export */ var pages_GuaranteePage = (GuaranteePage);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
;// CONCATENATED MODULE: ./pages/guarantee.js





function Guarantee() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
      title: "Our Guarantee"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(pages_GuaranteePage, {})]
  });
}

/***/ }),

/***/ 3788:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guarantee",
      function () {
        return __webpack_require__(573);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(3788); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);